import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { AppWindow } from '../mockups/AppWindow';
import { SystemMock } from '../mockups/SystemMock';
import { ParallaxFrame } from '../ui/ParallaxFrame';
import { PrimaryLink } from '../ui/PrimaryLink';
import { Reveal } from '../ui/Reveal';
export function SystemSection() {
  const {
    t
  } = useLanguage();
  return <section id="sistema" className="overflow-hidden bg-ink py-28 md:py-44" data-id="element-229" data-mp="3ofyyro5lgf1g">
      <div className="mx-auto max-w-6xl px-5 text-center md:px-6" data-id="element-230" data-mp="3odvzsemgrbkl">
        <Reveal data-id="element-231" data-mp="3t7gxs6o245js">
          <h2 className="text-5xl font-semibold leading-[1.02] tracking-[-0.035em] text-white md:text-8xl" data-id="element-232" data-mp="3t805kujztdk3">
            {t.system.title}
          </h2>
        </Reveal>
        <Reveal delay={0.08} data-id="element-233" data-mp="3jhxgh5fzsjr1">
          <p className="mx-auto mt-6 max-w-xl text-lg leading-snug text-muted md:text-2xl" data-id="element-234" data-mp="3jh5hdkn6s3w0">
            {t.system.text}
          </p>
        </Reveal>
        <Reveal delay={0.14} className="mt-8" data-id="element-235" data-mp="3agqtqemr2cpc">
          <PrimaryLink href="#informacion" variant="text" data-id="element-236" data-mp="3affqqh14p8za">
            {t.system.cta}
          </PrimaryLink>
        </Reveal>
        <ParallaxFrame className="mt-16 md:mt-24" distance={60} data-id="element-237" data-mp="6qy3s899qw93">
          <AppWindow className="border-white/[0.14]" data-id="element-238" data-mp="6qg1atw0jlsq">
            <SystemMock data-id="element-239" data-mp="kr8tv92r86t7" />
          </AppWindow>
        </ParallaxFrame>
      </div>
    </section>;
}